import React from "react"
import {Card, Container, Row, Col, Dropdown, Button} from 'react-bootstrap' 
import PenViewComponent from '../custom_counting_components/PenViewComponent'

export default class PenDescriptionCard extends React.Component {

  constructor(props) {
    super(props)

    
    this.feedlot_id = props.feedlot_id
    this.job_id = props.job_id

    // optional props
    this.is_admin = props.is_admin || false
    this.show_pen = props.show_pen || false
    this.is_modal = props.is_modal || false
    this.is_mobile = props.is_mobile || false

    this.is_editing = props.is_editing || false
    //this.job_finished = props.job_finished || false
    
    this.state = {
      pen_id: props.pen_id, // optional
      pen: null,
      heart_beats: [],
      modal_open: false,
    }

    this.getPen = this.getPen.bind(this)

    this.listener = this.subscribe()
    this.localMessageSubscriber = this.subscribeToLocalMessages()

    this.uploadImage = this.uploadImage.bind(this)
    this.editName = this.editName.bind(this)
    this.setArchive = this.setArchive.bind(this)

    if (this.is_admin == false) {
      this.currentWidth = window.innerWidth
      window.addEventListener("resize", () => {
        var previousWidth = this.currentWidth
        this.currentWidth = window.innerWidth
        if (this.currentWidth <= md_bp && previousWidth > md_bp) {
          this.forceUpdate()
        }
        if(this.currentWidth > md_bp && previousWidth <= md_bp) {
          this.forceUpdate()
        }
      });
    }
  }

  subscribeToLocalMessages() {
    var _this = this
    return postal.subscribe({
      channel: "PenDescriptionCard",
      topic: "pen_selection_changed",
      callback: function(data, envelope) {
        _this.setState({
          pen_id: data.pen_id,
          pen: null,
          heart_beats: []
        }, () => {
          _this.listener?.unsubscribe()
          $('#display-pen-modal').modal("show");
          _this.listener = _this.subscribe()
        })
      }
    });
  }

  render () {
    try {
      if (this.is_modal) {
        return (
          <div className="modal fade" id="display-pen-modal" role="dialog" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered" style={{minWidth: "90vw"}}>
              <div className="modal-content">
                <button className="close float-right mt-2 mx-auto" style={{position: "sticky", top: "15px", zIndex: "1", opacity: "1"}} aria-label="Close" data-dismiss="modal">
                  <span aria-hidden="true" className="p-1" style={{background: "white", borderRadius: "10px", opacity: "0.9"}}>Close</span>
                </button>
                <Container fluid className="modal-body" style={{padding: "0"}}>
                  {this.renderContent()}
                </Container>
              </div>
            </div>
          </div>
        )
      } else {
        return this.renderContent()
      }
    } catch (error) {
      console.log(error)
      Sentry.captureException(error)
      return null
    }
  }

  renderContent() {
    var pen = this.state.pen
    var pen_id = this.state.pen_id
    if(pen == null || pen_id == null) {
      return null
    }

    var is_admin = this.is_admin
    var condensed = this.is_admin == false ? this.currentWidth <= md_bp : false

    var pen_path = Routes.custom_counting_pen_path(pen_id)
    var job_path = Routes.custom_counting_job_path(this.job_id)
    var feedlot_path = Routes.feedlot_path(this.feedlot_id)

    return (
      <Card id="pen-view-component" className="m-2">
        <Card.Header>
          <Container fluid className="p-0">
            <Row>
              <Col xs="auto" className="p-0">
                <Card.Title style={{minWidth: "max-content", display: "block"}} className="m-0">
                  <a href={pen_path} style={{color: "inherit"}}>{`Image: ${pen.name}`}</a>
                  <div className="m-0" style={{fontSize: "0.7em"}}>
                    <a href={job_path} style={{color: "inherit"}}>{`Custom Job: ${pen.job_name}`}</a>
                  </div>
                  <div className="m-0" style={{fontSize: "0.7em"}}>
                    <a href={feedlot_path} style={{color: "inherit"}}>{`Feedlot: ${pen.feedlot_name}`}</a>
                  </div>
                </Card.Title>
              </Col>
            </Row>
            <Row>
              <Col xs="auto" className="p-0 mt-3">
                { pen.date_taken != null && 
                  <React.Fragment>
                    <br/>
                    <span className="nowrap" style={{fontSize: "1.1em"}}>
                      <span className="pr-1">
                        <b>Image Captured:</b>
                      </span>
                      <span className="">
                        {pen.date_taken}
                      </span>
                    </span>
                  </React.Fragment>
                }
              </Col>
              { this.is_editing == false && pen != null &&
                <Col xs="auto" className="p-0 mt-3 px-4">
                  <a className="btn btn-warning" href={Routes.edit_custom_counting_pen_path(pen_id)}>
                    Edit Detections
                  </a>
                </Col>
              }
              { this.is_editing == true &&
                <Col xs="auto" className="p-0 mt-3 px-4">
                  <a className="btn btn-info" href={Routes.custom_counting_pen_path(pen_id)}>
                    View Pen
                  </a>
                </Col>
              }
            </Row>
          </Container>
          <Dropdown>
            <Dropdown.Toggle 
              as="i" 
              className="btn-icon fas fa-ellipsis-v dropdown-no-arrow"
              bsPrefix=""
              style={{fontSize: "1.5em"}}>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {/*
                <Dropdown.Item href={pen_path} target="_blank">
                  View
                </Dropdown.Item>
              */}
              <Dropdown.Item href={Routes.original_picture_custom_counting_pen_path(pen_id)} target="_blank">
                View Original Image
              </Dropdown.Item>
              <Dropdown.Item onClick={this.editName}>
                Edit Name
              </Dropdown.Item>
              <Dropdown.Item onClick={this.uploadImage}>
                Upload Image
              </Dropdown.Item>
              <Dropdown.Item 
                className="text-danger"
                onClick={this.setArchive}>
                Archive
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Card.Header>
        <Card.Body style={{height: "auto", overflow: "hidden"}}>
          {this.generateClientView()}
          {(this.show_pen == true && this.state.pen != null) && 
            <Container fluid>
              <React.Fragment>
                <Row>
                  <Col xs={12} className="mb-2">
                    <PenViewComponent 
                      job_id={this.job_id}
                      pen_id={pen_id}
                      is_admin={this.is_admin}
                      is_mobile={this.is_mobile}
                      />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="d-inline-block float-right my-2">
                      {this.is_modal == false && 
                        <React.Fragment>
                          <a className="btn btn-primary" style={{marginLeft: "10px"}} href={Routes.next_custom_counting_pen_path(this.state.pen_id)+"?previous"}>
                            Previous
                          </a>
                          <a className="btn btn-primary" style={{marginLeft: "10px"}} href={Routes.next_custom_counting_pen_path(this.state.pen_id)}>
                            Next
                          </a>
                        </React.Fragment>
                      }
                      {this.is_modal == true &&
                        <React.Fragment>
                          <button className="btn btn-primary" style={{marginLeft: "10px"}} onClick={() =>
                            postal.publish({
                              channel: "PenListComponent",
                              topic: "next_pen",
                              data: {
                                previous: true
                              }
                            })
                          }>
                            Previous
                          </button>
                          <button className="btn btn-primary" style={{marginLeft: "10px"}} onClick={ () =>
                            postal.publish({
                              channel: "PenListComponent",
                              topic: "next_pen",
                              data: {
                                previous: false
                              }
                            })
                          }>
                            Next
                          </button>
                        </React.Fragment>
                      }
                      
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            </Container>
          }
        </Card.Body>
      </Card>
    )
  }

  generateClientView() {

    var pen = this.state.pen
    if(pen == null) {
      return null
    }

    return (
      <Container fluid>
        <Row className="row-gap-3 txt-md justify-content-around">
          <Col xs={6} md={4} lg="auto">
            <div className="w-100 text-center txt-xlg" >
              {/*<img src={this.hc_icon_path} className="pr-2" style={{height: "1.3em", verticalAlign: "middle"}}/>*/}
              <span style={{verticalAlign: "middle"}}>
                {numberWithCommas(pen.count || 0)}
              </span>
            </div>
            <div className="w-100 text-center" style={{fontWeight: "bold"}}>
              Count
            </div>
          </Col>
        </Row>
      </Container>
    )
  }

  subscribe() {
    if (this.state.pen_id != null) {
      var _this = this
      return App.cable.subscriptions.create(
        {
          channel: "CustomCountingChannels::PenDescriptionCardChannel",
          feedlot_id: this.feedlot_id,
          job_id: this.job_id,
          pen_id: this.state.pen_id,
          is_admin: this.is_admin
        },
        {  
          connected() {
            _this.getPen()
          },

          received(data) {
            if (data.pen != null) {
              _this.setState({
                pen: data.pen
              })
            } else if(data.message == "pen_updated") {
              _this.getPen()
            }
          }
        }
      )
    }
    return null
  }

  getPen() {
    this.listener.perform("get_pen")
  }

  uploadImage() {
    postal.publish({
      channel: "EditPenModal",
      topic: "open",
      data: {
        pen_id: this.state.pen_id,
        pen_name: this.state.pen.name,
        type: "upload_image"
      }
    })
  }

  editName() {
    postal.publish({
      channel: "EditPenModal",
      topic: "open",
      data: {
        pen_id: this.state.pen_id,
        pen_name: this.state.pen.name,
        type: "pen_name"
      }
    })
  }

  setArchive() {
    if (ask("Are You Sure You Want To Archive This Pen?")) {
      var jform = new FormData();
      jform.append('utf8',"&#x2713;");
      jform.append('authenticity_token',form_authenticity_token());
      
      $.ajax({
        url: Routes.archive_custom_counting_pen_path(this.state.pen_id),
        type: "POST",
        data: jform,
        dataType: 'json',
        mimeType: 'multipart/form-data',
        contentType: false,
        cache: false,
        processData: false,
        success: function(response) {
          if (response.status == "Success") {
            postAlert("success", `Successfully Archived Pen`)
            window.location.reload()
          } else {
            postAlert("danger", `Failed To Archive Pen`)
          }
        },
        error: function(request, textStatus, errorThrown) {
          postAlert("danger", `Failed To Archive Pen`)
        },
        complete: function() {}
      })
    }
  }
}